import AdaptiveQuizAttemptTable from './AdaptiveQuizAttemptTable';

export default AdaptiveQuizAttemptTable;
